import { useTranslation } from "@/i18n/useTranslation";
import { en } from "@/i18n/translations/en";
import { fr } from "@/i18n/translations/fr";

type SeoKey = keyof typeof en.seo;

export interface PageSeoEntry {
  title: string;
  description: string;
  keywords?: string;
}

/**
 * Returns localized SEO copy for a page key.
 * Falls back to EN if a key is missing in FR.
 */
export const usePageSeo = (key: SeoKey): PageSeoEntry => {
  const { locale } = useTranslation();
  const dict = locale === "fr" ? fr : en;
  const fallback = en.seo[key] as PageSeoEntry;
  const entry = ((dict.seo as Record<string, PageSeoEntry>)[key] ?? fallback) as PageSeoEntry;
  return entry;
};
